import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  originalDrives: null,
  drives: null,
  status: 'idle',
  error: null,
  selectedDriveName: null,
  selectedDriveVideoURL: null,
  selectedDriveId: null,
  deleteDriveLoading: false,
  deleteDriveError: null,
  storageUrl: null,
  statedrivesJson: null,
  statedrivesLoading: false,
  statedrivesError: null,
};

const driveSlice = createSlice({
  name: 'drive',
  initialState,
  reducers: {
    getDrivesStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    getDrivesSuccess: (state, action) => {
      state.status = 'success';
      state.drives = action.payload.data;
      state.originalDrives = action.payload.data;
      state.error = null;
    },
    getDrivesFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
    setSelectedDriveName: (state, action) => {
      state.selectedDriveName = action.payload;
    },
    setFilteredDrivesList: (state, action) => {
      state.drives = action.payload;
    },
    setSelectedDriveVideoURL: (state, action) => {
      state.selectedDriveVideoURL = action.payload;
    },
    setSelectedDriveID: (state, action) => {
      state.selectedDriveId = action.payload;
    },
    deleteDriveStart: (state) => {
      state.deleteDriveLoading = true;
      state.deleteDriveError = null;
    },
    deleteDriveSuccess: (state) => {
      state.deleteDriveLoading = false;
      state.deleteDriveError = null;
    },
    deleteDriveFailure: (state, action) => {
      state.deleteDriveLoading = false;
      state.deleteDriveError = action.payload.message;
    },
    getStorageUrl: (state, action) => {
      state.storageUrl = action.payload.data;
    },
    resetStorageUrl: (state) => {
      state.storageUrl = null;
    },
    clearDrives: (state) => {
      state.drives = null;
      state.originalDrives = null;
    },
    drivesStateStart: (state) => {
      state.statedrivesLoading = true;
      state.statedrivesError = null;
    },
    drivesStateSuccess: (state, action) => {
      state.statedrivesLoading = false;
      state.statedrivesJson = action.payload.data[0];
      state.statedrivesError = null;
    },
    drivesStateFailure: (state, action) => {
      state.statedrivesLoading = false;
      state.statedrivesError = action.payload.message;
    },
  },
});

export const {
  getDrivesStart,
  getDrivesSuccess,
  getDrivesFailure,
  setSelectedDriveName,
  setFilteredDrivesList,
  setSelectedDriveVideoURL,
  setSelectedDriveID,
  deleteDriveStart,
  deleteDriveSuccess,
  deleteDriveFailure,
  getStorageUrl,
  resetStorageUrl,
  clearDrives,
  drivesStateStart,
  drivesStateSuccess,
  drivesStateFailure,
} = driveSlice.actions;

export default driveSlice.reducer;
